import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import NewsBox from './NewsBox';
import NewsModal from './NewsModal';
import HomeNewsBox from './HomeNewsBox';

class NewsModalSwitch extends Component {

  render() {
    const { data, isShortNews } = this.props;

    return (
      <React.Fragment>
        <Switch>
          <Route
            exact
            path="/"
            render={() => <HomeNewsBox data={data} isShortNews={isShortNews} />}
          />
          <Route
            path="/news/:filter"
            render={(props) => <NewsBox data={data} isShortNews={isShortNews} {...props} />}
          />
        </Switch>
      
        <Route
          path="/news/detail/:id"
          render={props => ( props.match.params.id === data.id ? 
            <NewsModal data={data} {...props} /> : null
          )}
        />        
      </React.Fragment>
    );
  }
}

NewsModalSwitch.propTypes = {
  data: PropTypes.shape({
    date: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string
  }),
  isShortNews: PropTypes.bool,
  location: PropTypes.shape({}),
};

NewsModalSwitch.defaultProps = {
  data: {
    date: new Date().toISOString(),
    type: 'news',
    title: 'Dummy title',
    content: 'Dummy content'
  },
  isShortNews: true,
  location: {},
};

export default NewsModalSwitch;



// WEBPACK FOOTER //
// ./src/components/NewsModalSwitch.js